import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalEditorFlipVerticalIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon image-modal-editor-flip-vertical"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M2.5 10H5m3.75 0h2.5M15 10h2.5M6.659 17.26l2.813-3.656c.18-.234.27-.351.379-.393a.42.42 0 0 1 .298 0c.11.042.2.159.38.393l2.812 3.656c.265.345.398.517.396.662a.42.42 0 0 1-.159.322c-.113.09-.33.09-.765.09H7.187c-.435 0-.652 0-.766-.09a.42.42 0 0 1-.158-.322c-.002-.145.13-.317.396-.662m0-14.52 2.813 3.656c.18.234.27.351.379.393a.42.42 0 0 0 .298 0c.11-.042.2-.159.38-.393L13.34 2.74c.265-.345.398-.517.396-.662a.42.42 0 0 0-.159-.322c-.113-.09-.33-.09-.765-.09H7.187c-.435 0-.652 0-.766.09a.42.42 0 0 0-.158.322c-.002.145.13.317.396.662"
        />
    </svg>
);
const Memo = memo(ImageModalEditorFlipVerticalIcon);
export default Memo;
